<template>
    <div>
      <a-card class="m-height-full m-display-flex flex-column">
        <div slot="title">
          <span>{{ this.id ? 'Edit' : 'Create' }} Budget</span>
        </div>
        <template slot="extra">
        </template>
        <a-spin
          :spinning="loading.page"
          tip="Preparing To Show Data ...  "
        >
          <div class="container-essential">
            <a-form :form="form">
              <a-row :gutter="24" style="display: flex;">
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <a-form-item label="Budget Type">
                    <a-select
                      showSearch
                      v-decorator="['budget_type', { rules: [{ required: true }] }]"
                      :disabled="lock_header"
                      @change="setBudget"
                    >
                      <a-select-option v-for="item in budget_list" :key="item.jns_anggaran_id">
                        {{ item.jns_anggaran_id }} - {{ item.nm_anggaran }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Budget Year">
                    <a-select
                      showSearch
                      v-decorator="['periode', { rules: [{ required: true }] }]"
                      :disabled="lock_header"
                      @change="setPeriode"
                    >
                      <a-select-option v-for="item in year_list" :key="item">
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="RC Code">
                    <a-select
                      showSearch
                      v-decorator="['rc_code', { rules: [{ required: true }] }]"
                      :disabled="lock_header"
                      :loading="loading_rc"
                      @change="onChangeRc"
                    >
                      <a-select-option v-for="item in rc_code_list" :key="item.project_id" :value="item.project_id">
                        {{ item.cost_center_kode }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="Upload Template Excel">
                    <a-upload
                      :fileList="fileList"
                      v-decorator="[
                        'file_upload',
                        { rules: [{ required: true,validator: doc_validation }]},
                      ]"
                      :remove="handleRemove"
                      :beforeUpload="beforeUpload"
                    >
                      <a-button :disabled="lock_header">
                        <a-icon type="upload" />Select File
                      </a-button>
                    </a-upload>
                    <!-- <small>**If you dont have a file upload template, please click 
                      <a-button type="link" class="padding-remove" @click="handleDownloadTemplate">
                        <small>Download Template</small>
                      </a-button>
                    </small> -->
                  </a-form-item>
                  
                  <div>
                    <a-button type="primary" class="margin-top" @click="handlePreview" :loading="loading.preview" :disabled="lock_header">
                      Preview
                    </a-button>
                    <a-button v-if="lock_header" type="danger" class="margin-left" @click="handleReset" :loading="loading.reset">
                      Reset
                    </a-button>
                  </div>
                </a-col>

                <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
                  <a-row :gutter="16" type="flex" class="side-preview">
                    <a-col :gutter="16" :xs="{ span: 12 }" :lg="{ span: 8 }">
                      
                      <div class="list-item">
                        <label for="" class="title">BUDGET TYPE</label>
                        <span>{{ stateRc.budget_type ? stateRc.budget_type : '-' }}</span>
                      </div>

                      <div class="list-item">
                        <label for="" class="title">COST CENTER CODE</label>
                        <span>{{ stateRc.cost_center_kode ? stateRc.cost_center_kode : '-' }}</span>
                      </div>

                      <div class="list-item">
                        <label for="" class="title">JOB NAME</label>
                        <span>{{ stateRc.job_name ? stateRc.job_name : '-' }}</span>
                      </div>

                      <div class="list-item">
                        <label for="" class="title">FISCAL YEAR</label>
                        <span>{{ stateRc.fiscal_year ? stateRc.fiscal_year : '-' }}</span>
                      </div>

                      <div class="list-item">
                        <label for="" class="title">COMPILER</label>
                        <span>{{ stateRc.compiler ? stateRc.compiler : '-' }}</span>
                      </div>

                      <div class="list-item">
                        <label for="" class="title">SITE</label>
                        <span>{{ stateRc.site ? stateRc.site : '-' }}</span>
                      </div>

                    </a-col>

                    <a-col :gutter="16" :xs="{ span: 12 }" :lg="{ span: 8 }">
                      
                      <div class="list-item">
                        <label for="" class="title">BUDGET GA AUTHORITY</label>
                        <span>{{ stateRc.budget_ga_authority ? stateRc.budget_ga_authority : '-' }}</span>
                      </div>

                      <div class="list-item">
                        <label for="" class="title">BUDGET MARKETING/IBD</label>
                        <span>{{ stateRc.budget_marketing_ibd ? stateRc.budget_marketing_ibd : '-' }}</span>
                      </div>

                      <div class="list-item">
                        <label for="" class="title">BUDGET OPERATION AUTHORITY</label>
                        <span>{{ stateRc.budget_operation_authority ? stateRc.budget_operation_authority : '-' }}</span>
                      </div>

                      <!-- <div class="list-item">
                        <label for="" class="title">BUDGET GENERAL AFFAIR</label>
                        <span>{{ stateRc.budget_ga_authority ? stateRc.budget_ga_authority : '-' }}</span>
                      </div>

                      <div class="list-item">
                        <label for="" class="title">BUDGET FINANCE</label>
                        <span>{{ stateRc.budget_finance_authority ? stateRc.budget_finance_authority : '-' }}</span>
                      </div> -->

                      <div class="list-item">
                        <label for="" class="title">BUDGET DIRECTORATE</label>
                        <span v-if="stateRc.project_direktorat">{{ stateRc.project_direktorat+stateRc.pic_direktorat}}</span>
                        <b v-else style="color:red">-- NOT SET YET --</b>
                      </div>

                      <div class="list-item" v-if="stateRc && stateRc.budget_type && stateRc.budget_type.includes('(02)')">
                        <label for="" class="title">DEPARTMENT</label>
                        <span v-if="stateRc.project_departmen">{{ stateRc.project_departmen+" - "+stateRc.project_departmen}}</span>
                        <b v-else style="color:red">-- NOT SET YET --</b>
                      </div>

                      <div class="list-item" v-if="stateRc && stateRc.budget_type && stateRc.budget_type.includes('(02)')">
                        <label for="" class="title">HEAD OF DEPARTMENT</label>
                        <span v-if="stateRc.pic_direktorat">{{ stateRc.pic_direktorat}}</span>
                        <b v-else style="color:red">-- NOT SET YET --</b>
                      </div>

                    </a-col>

                    <a-col :gutter="16" :xs="{ span: 12 }" :lg="{ span: 8 }">
                      
                      <div class="list-item">
                        <label for="" class="title">SALES NOTIF NUMBER</label>
                        <span>{{ stateRc.notif_number ? stateRc.notif_number : '-' }}</span>
                      </div>

                      <div class="list-item">
                        <label for="" class="title">PLAFON TYPE</label>
                        <span>{{ stateRc.plafon ? stateRc.plafon : '-' }}</span>
                      </div>

                    </a-col>
                  </a-row>
                </a-col>

              </a-row>
              <a-divider class="margin-small"/>
              <a-row :gutter="16" type="flex" justify="end">
                <!-- <a-col>
                  <a-button type="primary" class="margin-top" @click="handlePreview" :loading="loading.preview" :disabled="lock_header">
                    Preview
                  </a-button>
                  <a-button v-if="lock_header" type="danger" class="margin-left" @click="handleReset" :loading="loading.reset">
                    Reset
                  </a-button>
                </a-col> -->
              </a-row>
            </a-form>
          </div>
          <a-table
            class="ccd margin-top"
            :columns="columns"
            :rowKey="(record, index) => {return index;}"
            :dataSource="dataSource.data"
            :pagination="false"
            size="small"
            :scroll="{ x: 1920 }"
            bordered
          >
            <template slot="title">
              <a-row :gutter="16" type="flex" justify="space-between" align="middle">
                <a-col>
                  <div class="ant-card-head-title" ><b>Budget Detail</b></div>
                </a-col>
                <a-col>
                  <a-input-search
                    v-model="search"
                    placeholder="Search Budget Detail .. "
                  />  
                </a-col>
              </a-row>
            </template>

            <template slot="no" slot-scope="text, data, index">
              {{ index + 1 }}
            </template>

            <template slot="budget" slot-scope="item, data, index">
              <span style="display: block; text-align: left;" :class="itemChild(data)">{{ item }}</span>
            </template>

            <template slot="kode_anggaran" slot-scope="item">
              <span>{{ item }}</span>
            </template>

            <template slot="unit_price" slot-scope="item, data, index">
              <CurrencyJustified
                v-if="data.type == 'item'"
                currencyValue="IDR"
                :valueNumber="item"
              />
            </template>

            <template v-for="bln in bulan" :slot="bln.bulan" slot-scope="item, data, index">
              <CurrencyJustified
              v-if="data.type == 'item'"
                currencyValue="IDR"
                :valueNumber="item"
              />
            </template>

            <template slot="sub_total" slot-scope="item, data, index">
              <CurrencyJustified
                v-if="data.type == 'item'"
                currencyValue="IDR"
                :valueNumber="item"
              />
            </template>

            <template slot="deskripsi" slot-scope="item">
              {{ item.keterangan }}
            </template>

            <template slot="footer">
              <a-row :gutter="16" type="flex" justify="space-between" align="top">
                <!-- <a-col style="text-align: right;">
                  <a-statistic title="Total Deduction Value (IDR)" :value="total_deduction" />
                  <a-button type="primary" icon="save" class="margin-top" @click="handleSubmit" :loading="loading.submit" :disabled="!lock_header">Submit</a-button>
                </a-col> -->
              </a-row>
            </template>
          </a-table>

          <a-card class="m-height-full m-display-flex flex-column margin-top-10">
            <div slot="title">
              <span><b>Action</b></span>
            </div>
            <div class="container-essential">
              <a-row :gutter="16">
                <a-col :gutter="16" :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <div class="action-card">
                    <div class="m-display-flex flex-row">
                      <span class="margin-remove"><b>Approval Budget</b></span>
                      </div>
                    <a-timeline class="m-timeline-content margin-top">
                      <a-timeline-item v-for="(timeline, index) in timeline" :key="index"
                        class="m-display-flex flex-row nowrap" color="green">
                        <span class="margin-right">{{ timeline.actor }} - {{ timeline.tlc }}</span> 
                        <!-- <status :class="getScreen ? 'margin-remove' : ''" :status="timeline.tlc" /> -->
                      </a-timeline-item>
                    </a-timeline>
                  </div>
                </a-col>

                <a-col :gutter="16" :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form :form="form">
                    <a-form-item label="Note">
                      <a-textarea
                        placeholder="Write the note here ... "
                        :rows="4"
                        v-decorator="[
                          'catatan',
                          { rules: [{ required: false }] },
                        ]"
                      />
                    </a-form-item>
                  </a-form>
                  <div style="display: flex; justify-content: end;">
                    <a-button style="" type="primary" icon="save" @click="handleSubmit" :loading="loading.submit">Submit</a-button>
                  </div>
                </a-col>
              </a-row>
            </div>
            
          </a-card>
          
        </a-spin>
      </a-card>
    </div>
  </template>
  <script>
  import { mapGetters } from "vuex";
  import axios from "axios";
  import moment from "moment";
  import _ from "lodash";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import HandleRoute from "@/mixins/HandleRoute";
  import GlobalMethod from "@/mixins/GlobalMethod.js";

  const bulan = [
    { bulan: "januari", short: "jan" },
    { bulan: "februari", short: "feb" },
    { bulan: "maret", short: "mar" },
    { bulan: "april", short: "apr" },
    { bulan: "mei", short: "mei" },
    { bulan: "juni", short: "jun" },
    { bulan: "juli", short: "jul" },
    { bulan: "agustus", short: "agu" },
    { bulan: "september", short: "sep" },
    { bulan: "oktober", short: "okt" },
    { bulan: "november", short: "nov" },
    { bulan: "desember", short: "des" }
  ];
  
  export default {
    name: "cooperative-deduction-create",
    mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
    props: ["id"],
    data(){
      let doc_validation = (rule, value, callback) => {
        if (this.fileList.length==0) {
          callback(new Error("Please Complete Your Form Input!"));
        } else {
          callback();
        }
      };
      return {
        doc_validation,
        fileList: [],
        loading: {
          preview: false,
          submit: false,
          page: false,
          reset: false
        },
        option: {
          periode : []
        },
        dataSource: {
          data: [],
          dataOriginal: [],
          dataEditOriginal: []
        },
        bulan,
        search: "",
        total_deduction: 0,
        lock_header: false,
        formAction: {
          note: '',
        },
        timeline: [],
        budget_list: [],
        rc_code_list: [],
        year_list: [],
        loading_rc: false,
        budget_selected: '',
        year_selected: '',
        stateRc: {}
      }
    },
    beforeCreate() {
      this.form = this.$form.createForm(this);
    },

    created(){
      this.initialFetch()
    },

    mounted(){
      this.generateOption()
      if(this.id){
        this.fetchEditData()
      }
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getDefaultDateFormat",
        "getCostCenter",
        "getPeruntukan",
        "getSubPeruntukan",
        "getAnggaran",
      ]),
      columns(){
        const kolom = [
          {
            title: "No",
            dataIndex: "no",
            key: "no",
            width: "60px",
            align: "center",
            scopedSlots: { customRender: "no" },
          },
          {
            title: "Budgeting",
            dataIndex: "budget",
            key: "budget",
            width: "170px",
            align: "center",
            scopedSlots: { customRender: "budget" }
          },
          {
            title: 'Year ' + this.year_selected,
            children: [
              {
                title: "Code Budget",
                dataIndex: "kode_anggaran",
                key: "kode_anggaran",
                width: "170px",
                scopedSlots: { customRender: "kode_anggaran" },
              },
              {
                title: "Unit",
                dataIndex: "unit",
                key: "unit",
                align: "center",
                scopedSlots: { customRender: "unit" },
              },
              {
                title: "Unit Price",
                dataIndex: "unit_price",
                key: "unit_price",
                scopedSlots: { customRender: "unit_price" },
              },
              {
                title: "Jan",
                dataIndex: "januari",
                key: "januari",
                scopedSlots: { customRender: "januari" },
              },
              {
                title: "Feb",
                dataIndex: "februari",
                key: "februari",
                scopedSlots: { customRender: "februari" },
              },
              {
                title: "Mar",
                dataIndex: "maret",
                key: "maret",
                scopedSlots: { customRender: "maret" },
              },
              {
                title: "Apr",
                dataIndex: "april",
                key: "april",
                scopedSlots: { customRender: "april" },
              },
              {
                title: "May",
                dataIndex: "mei",
                key: "mei",
                scopedSlots: { customRender: "mei" },
              },
              {
                title: "Jun",
                dataIndex: "juni",
                key: "juni",
                scopedSlots: { customRender: "juni" },
              },
              {
                title: "Jul",
                dataIndex: "juli",
                key: "juli",
                scopedSlots: { customRender: "juli" },
              },
              {
                title: "Aug",
                dataIndex: "agustus",
                key: "agustus",
                scopedSlots: { customRender: "agustus" },
              },
              {
                title: "Sep",
                dataIndex: "september",
                key: "september",
                scopedSlots: { customRender: "september" },
              },
              {
                title: "Okt",
                dataIndex: "oktober",
                key: "oktober",
                scopedSlots: { customRender: "oktober" },
              },
              {
                title: "Nov",
                dataIndex: "november",
                key: "november",
                scopedSlots: { customRender: "november" },
              },
              {
                title: "Des",
                dataIndex: "desember",
                key: "desember",
                scopedSlots: { customRender: "desember" },
              },
              {
                title: "Sub Total",
                dataIndex: "sub_total",
                key: "sub_total",
                align: "right",
                scopedSlots: { customRender: "sub_total" },
              },
            ]
          }
        ]
          return kolom
      },
    },
    methods:{
      handleRemove() {
        if(!this.lock_header)
          this.fileList = [];
      },
      beforeUpload(file) {
        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 5) {
          this.displayMessage("large-file-5mb");
        } else {
          this.fileList = [];
          this.fileList.push(file);
          return false;
        }
      },
      onSearch(){
  
      },
      handleDownloadTemplate(){
        this.asyncAxiosGet("potongan_koperasi/template",
          this.getAuth,
          {}
        )
        .then((response) => {
          window.open(this.$serviceUrl + response.url, "_blank");
        })
        .catch((err) => {
          console.log(err);
          this.displayMessage("error-emptyDocTemplate");
        });
      },
      handlePreview(){
        this.form.validateFields((err, values) => {
          console.log(values);
          
          if (err) {
            this.displayMessage("choose-action");
            return;
          }
          
          let data = new FormData();
          data.append("jns_anggaran_id", values.budget_type);
          data.append("year", values.periode);
          data.append("project_id", values.rc_code);
          data.append("file_upload", this.fileList[0]);
  
          this.loading.preview = true
          this.asyncAxiosPost(
            "anggaran/preview",
            "formdata",
            this.getAuth,
            data
          ).then((response) => {
            this.dataSource.data = response.dtl
            this.dataSource.dataOriginal = this.dataSource.data
  
            this.total_deduction = response.total
            this.lock_header = true
            this.loading.preview = false
          })
          .catch(() => {
            this.loading.preview = false
          });
        })
      },
      generateOption(){
        let thn = [moment().format('YYYY'), moment().subtract(1, 'year').format('YYYY')]
        for (let index = 0; index < thn.length; index++) {
          for (let index2 = 0; index2 < 12; index2++) {
            this.option.periode.push({
              value: moment().set('year', thn[index]).set('month', 11-index2).format('YYYY-MM'),
              label: moment().set('year', thn[index]).set('month', 11-index2).format('MMMM YYYY')
            })
          }
        }
        
      },
      handleSubmit(){
        const that = this;
        let title = "";
        title = "Are you sure to Submit this data?";
        that.$confirm({
          title: title,
          content: "Yes / No?",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            that.form.validateFields((err, values) => {
              if (err) {
                that.displayMessage("choose-action");
                return;
              }
              
              let data = new FormData();

              try {
                data.append("jns_anggaran_id", values.budget_type);
                data.append("year", values.periode);
                data.append("project_id", values.rc_code);
                data.append("note", values.catatan);
                data.append("file_upload", that.fileList[0]);

                // const response = await that.asyncAxiosPost(
                //   "anggaran",
                //   "formdata",
                //   that.getAuth,
                //   data
                // )
                if(response){
                  that.displayMessage("success-save")
                  that.$router.push({ name: "budget" });
                }

              } catch (error) {
                console.log(error);
                that.loading.submit = false
              }
  
              that.loading.submit = true
              that.asyncAxiosPost(
                "anggaran",
                "formdata",
                that.getAuth,
                data
              ).then(() => {
                that.displayMessage("success-save")
                that.$router.push({ name: "budget" });
              })
              .catch(() => {
                that.loading.submit = false
              });
            })
          },
          onCancel() {},
        })
      },
      async handleReset(){
        this.loading.reset = true
        if(this.id){
          this.dataSource.data = this.dataSource.dataEditOriginal.dtl
          this.dataSource.dataOriginal = this.dataSource.dataEditOriginal.dtl
  
          await this.convertfiles(this.dataSource.dataEditOriginal.header.lampiran, 
            this.dataSource.dataEditOriginal.header.lampiran_path, 
            this.dataSource.dataEditOriginal.header.lampiran_file)
          this.$nextTick(function () {
            this.form.setFieldsValue({
              periode: this.dataSource.dataEditOriginal.header.periode,
              description: this.dataSource.dataEditOriginal.header.description,
              // file_upload: this.fileList[0],
            });
          })
          this.total_deduction = this.dataSource.dataEditOriginal.header.total
          this.lock_header = false
        }else{
          this.dataSource.data = []
          this.dataSource.dataOriginal = [] 
          this.fileList = []
          this.total_deduction = 0
          this.lock_header = false
        }
        this.loading.reset = false
      },
      fetchEditData(){
        this.loading.page = true
        this.asyncAxiosGet("potongan_koperasi",
          this.getAuth,
          {id_potongan: this.id}
        )
        .then(async (response) => {
          this.dataSource.dataEditOriginal = response
          this.dataSource.data = response.dtl
          this.dataSource.dataOriginal = this.dataSource.data
  
          await this.convertfiles(response.header.lampiran, response.header.lampiran_path, response.header.lampiran_file)
          this.$nextTick(function () {
            this.form.setFieldsValue({
              periode: response.header.periode,
              description: response.header.description,
              // file_upload: this.fileList[0],
            });
          });
          
          this.total_deduction = Number(response.header.total)
          this.lock_header = false
          this.loading.page = false
        })
        .catch((err) => {
          console.log(err);
        });
      },
      convertfiles(file_name, url, file64) {
        let typefile = file_name.substr(file_name.lastIndexOf("."));
  
        if (typefile == ".xls") {
          typefile = "data:application/vnd.ms-excel;base64,";
        } else if (typefile == ".xlsx") {
          typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
        } else if (typefile == ".doc") {
          typefile = "data:application/msword;base64,";
        } else if (typefile == ".docx") {
          typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
        } else if (typefile == ".pdf") {
          typefile = "data:application/pdf;base64,";
        } else if (typefile == ".jpeg" || typefile == ".jpg") {
          typefile = "data:image/jpeg;base64,";
        } else if (typefile == ".png") {
          typefile = "data:image/png;base64,";
        }
  
        var file = this.dataURLtoFile(
          typefile + file64,
          file_name
        );
        file.uid = "vc-upload-1-1";
        file.status = "done";
        file.exist = true;
        file.url = this.$serviceUrl + url;
        this.fileList = [file];
      },

      initialFetch(){
        this.asyncAxiosGet("anggaran/create",
          this.getAuth,{}
        ).then((response) => {
          this.budget_list = response.budget_type
          this.year_list = response.year
        }).catch((err) => {
          console.log(err);
        })
      },

      setBudget(val){
        this.budget_selected = val
        this.clearRc()
      },

      setPeriode(val){
        this.year_selected = val
        this.clearRc()
      },

      clearRc(){
        this.rc_code_list = []
        this.form.setFieldsValue({
          rc_code: ''
        })
        this.stateRc = {}
      },

      onChangeRc(val){
        const value = this.rc_code_list.find((e) => e.project_id == val)
        if(value){
          this.stateRc = value
        }else this.stateRc = {}
      },

      checkBudgetFilters() {
        if (this.budget_selected && this.year_selected) {
          this.loading_rc = true
          this.asyncAxiosGet("anggaran/create",
            this.getAuth,
            {jns_anggaran_id: this.budget_selected, year: this.year_selected}
          ).then((response) => {
            this.rc_code_list = response.data_project
            this.timeline = response.workflow
            this.loading_rc = false
          }).catch((err) => {
            console.log(err);
            this.loading_rc = false
            
          })
        }
      },

      itemChild(val){
        let c = ''
        if(val.kode_anggaran == null){
          c = 'text-bold';
          if(val.type == 'peruntukan'){
            c = c + ' margin-1'
          } else if(val.type == 'subperuntukan'){
            c = c + ' margin-2'
          }
        }else {
          c = 'margin-item'
        }

        return c;
      }
    },
    watch:{
      "search"(val){
        if(val){ 
          this.dataSource.data = this.dataSource.dataOriginal.filter(item => item.tlc.toLowerCase().indexOf(val.toLowerCase()) >=0 )
        }else{
          this.dataSource.data = this.dataSource.dataOriginal
        }
      },

      budget_selected() {
        this.checkBudgetFilters()
      },
      year_selected() {
        this.checkBudgetFilters()
      }
    }
  
  }
  </script>
  <style lang="less" scoped>
  .ccd:deep{
    .ant-table-body{
      thead {
        th {
          text-transform: uppercase;
          text-align: center;
        }
      }
    }
  }
  </style>
  <style lang="less">
    .r_same { 
      background-color: fade(@color-secondary, 35%)!important;
    }
  
    .r_not_same { 
      background-color: fade(@color-primary, 35%)!important;
    }

    .side-preview {
      display: flex;
      flex-grow: 1;
      width: 100%;
      height: 100%;
      background-color: white;
      padding: 10px;
      border-radius: 5px;
    }

    .side-preview .title {
      font-weight: bold;
    }

    .list-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
    }

    // .list-item label + span {
    //   text-transform: uppercase;
    // }

    .margin-top-10 {
      margin-top: 14px;
    }

    .action-card {
      width: 100%;
      height: 100%;
      background-color: white;
      padding: 10px;
      border-radius: 5px;
    }

    .text-bold {
      font-weight: bold;
    }

    .margin-1 {
      margin-left: 10px;
    }

    .margin-2 {
      margin-left: 20px;
    }

    .margin-item {
      margin-left: 30px;
    }

  </style>